module.exports = __webpack_public_path__ + "img/cards.5523a24e.png";